/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back`)
};

const es_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido de nuevo`)
};

const de_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen zurück`)
};

const nl_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welkom terug`)
};

const fr_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon retour`)
};

const it_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bentornato`)
};

const pt_br2_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo de volta`)
};

const pt_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo de volta`)
};

const ja_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おかえりなさい`)
};

const zh_auth_welcome_back = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎回来`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_welcome_back = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_welcome_back(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_welcome_back", locale)
	if (locale === "en") return en_auth_welcome_back(inputs)
	if (locale === "es") return es_auth_welcome_back(inputs)
	if (locale === "de") return de_auth_welcome_back(inputs)
	if (locale === "nl") return nl_auth_welcome_back(inputs)
	if (locale === "fr") return fr_auth_welcome_back(inputs)
	if (locale === "it") return it_auth_welcome_back(inputs)
	if (locale === "pt-BR") return pt_br2_auth_welcome_back(inputs)
	if (locale === "pt") return pt_auth_welcome_back(inputs)
	if (locale === "ja") return ja_auth_welcome_back(inputs)
	return zh_auth_welcome_back(inputs)
};